module.exports = __webpack_public_path__ + "img/arrow-circle-left.4fbfe4fe.png";